import { createContext } from 'react';

import { FormControlContextType } from './ControlBaseContext.types';

export const FormControlContext = createContext<FormControlContextType | undefined>(undefined);
